import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, AlertCircle, Home, FileText } from 'lucide-react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const PaymentFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-container">
      <Header />
      <div className="dashboard-wrapper">
        <Sidebar activeItem="application" />
        <div className="flex-grow-1 dashboard-content">
          <div className="payment-failure-container">
            <div className="payment-failure-card">
              <div className="text-center mb-4">
                <XCircle size={64} className="text-danger mb-3" />
                <h2 className="text-danger mb-3">Payment Failed</h2>
                <p className="text-muted mb-4">
                  We were unable to process your payment. Your application has not been submitted.
                </p>
              </div>

              <div className="failure-info">
                <h5>What might have happened?</h5>
                <ul className="failure-reasons">
                  <li>Payment was cancelled by you or the payment gateway</li>
                  <li>Insufficient funds in your account</li>
                  <li>Network connectivity issues</li>
                  <li>Payment method declined by the bank</li>
                  <li>Session timeout during payment</li>
                </ul>
              </div>

              <div className="help-section">
                <h5><AlertCircle size={20} className="text-warning me-2" />Need Help?</h5>
                <p>If you continue to face issues, please contact our support team:</p>
                <ul className="contact-info">
                  <li>Email: support@balurghatswimmingpool.com</li>
                  <li>Phone: +91-1234567890</li>
                  <li>Visit: Balurghat Municipality Swimming Pool Office</li>
                </ul>
              </div>

              <div className="action-buttons">
                <button 
                  className="enhanced-btn btn-primary"
                  onClick={() => navigate('/application')}
                >
                  <FileText size={20} />
                  <span>Try Again</span>
                </button>
                <button 
                  className="enhanced-btn btn-secondary"
                  onClick={() => navigate('/dashboard')}
                >
                  <Home size={20} />
                  <span>Go to Dashboard</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
